module.exports = __webpack_public_path__ + "static/media/xylophone.01203b9a.svg";